// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const profileVisitsHistoryConfig = {
    title: 'chart.instagram.profile_visits',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.instagram.profile_visits'
    },
    id: 'profile_visits_history',
    color: {
        value: 'green'
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.instagram.tooltip_profile_visits',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
